import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCircleNotReturned = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            >
            <path
                fill={color}
                fillRule="evenodd"
                d="M7.922 14.48c.29.28.76.28 1.047 0a.698.698 0 000-1.011l-1.204-1.163h1.3c.343 0 .678-.035 1-.1.16-.307.364-.591.606-.842a3.442 3.442 0 012.354-1.059 4.52 4.52 0 00.858-2.65c0-2.57-2.156-4.652-4.818-4.652L4.741 3A.727.727 0 004 3.716c0 .396.33.715.741.715h4.324c1.84 0 3.336 1.443 3.336 3.22 0 1.777-1.495 3.22-3.336 3.22h-1.3L8.969 9.71a.695.695 0 000-1.011.76.76 0 00-1.047 0l-2.47 2.385a.695.695 0 000 1.011l2.47 2.385zm7.596-2.237a2.822 2.822 0 00-2.03-.87c-.761 0-1.491.313-2.03.87a3.024 3.024 0 00-.84 2.1c0 .789.303 1.544.84 2.101.539.557 1.269.87 2.03.87.761 0 1.491-.313 2.03-.87.538-.557.84-1.312.84-2.1s-.302-1.544-.84-2.1zm.468 4.686a3.473 3.473 0 01-2.498 1.07 3.473 3.473 0 01-2.498-1.07 3.722 3.722 0 01-1.034-2.585c0-.97.372-1.9 1.034-2.585a3.473 3.473 0 012.498-1.071c.937 0 1.835.385 2.498 1.07a3.722 3.722 0 011.035 2.586c0 .97-.373 1.9-1.035 2.585zM12.37 13.67a.35.35 0 010-.484.322.322 0 01.468 0l.649.671.648-.671a.323.323 0 01.468 0 .35.35 0 010 .484l-.648.671.648.671c.13.133.128.35 0 .485a.322.322 0 01-.468 0l-.648-.672-.649.672a.323.323 0 01-.467 0 .35.35 0 010-.484l.648-.672-.649-.67z"
                clipRule="evenodd"
            ></path>
        </svg>
    </div>
);

export default IconCircleNotReturned;